import { Component, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from '../../services/local-storage.service';
import { ToastService, ToastType } from '../../services/toast.service';
import { ListingCheckoutService } from '../../services/listing-checkout.service';
import { MyListingsService } from '../../services/my-listings.service';

@Component({
  selector: 'app-addon',
  templateUrl: './addon.component.html',
  styleUrls: ['./addon.component.css'],
})
export class AddonComponent {

  constructor(
    private router: Router,
    public localStorageService: LocalStorageService,
    public toastService: ToastService,
    public listingCheckoutService: ListingCheckoutService,
    public myListingsService: MyListingsService
  ) { }

  isAddonClosed: boolean = true;
  isButtonLoader: boolean = false;
  historyState: any;
  selectedPlan: any;
  addonData = [];
  mlsService = [];
  selectedAddons = [];
  selectedMls = [];
  totalAmount: number = 0;
  myListingId: string;
  isLoader: boolean = false;

  ngOnInit(): void {
    this.historyState = history.state;
    this.myListingId = this.historyState.myListingId ? this.historyState.myListingId : this.localStorageService.get('myListingId') ? this.localStorageService.get('myListingId') : null;

    this.selectedPlan = this.historyState.plansData;
    this.calculateTotal();

    if (this.selectedPlan && this.selectedPlan.packageid) {
      this.isButtonLoader = true;

      this.listingCheckoutService.GetListingCheckoutToken().subscribe(
        {
          next: (res) => {
            if (res && res.access_token) {
              this.localStorageService.set('lcAccessToken', res.access_token);
              this.getAddOns();
              this.getMlsServices();
            } else {
              this.isButtonLoader = false;
              console.log('GetListingCheckoutToken Fails!!!!');
            }
          },
          error: (err) => {
            this.isButtonLoader = false;
            console.log("GetListingCheckoutToken err : ", err);
          }
        }
      );


    } else {
      console.log('packageid missing!!!!');
    }

    if (this.historyState.totalAmount && this.historyState.from != 'plans') {
      this.totalAmount = this.historyState.totalAmount;
    }
  }

  getAddOns() {
    this.listingCheckoutService.GetPackageItems(this.selectedPlan.packageid).subscribe(
      {
        next: (res) => {

          if (res && res.length > 0) {
            if (this.historyState.addOnsData && this.historyState.from != 'plans') {
              this.selectedAddons = this.historyState.addOnsData;
              for (let idx = 0; idx < res.length; idx++) {
                let ele = res[idx];
                let isFlag = true;
                for (let index = 0; index < this.historyState.addOnsData.length; index++) {
                  let element = this.historyState.addOnsData[index];
                  if (element.id == ele.id) {
                    ele.isAdded = true;
                    this.addonData.push(ele);
                    isFlag = false;
                    break;
                  }
                }
                if (isFlag) {
                  this.addonData.push(ele);
                }
              }
            } else {
              this.addonData = res;
            }
            this.calculateTotal();
            this.isButtonLoader = false;
          } else {
            this.isButtonLoader = false;
            console.log('GetPackageItems Fails!!!!');
          }
        },
        error: (err) => {
          this.isButtonLoader = false;
          console.log("GetPackageItems err : ", err);
        }
      }
    );
  }

  getMlsServices() {
    this.listingCheckoutService.GetMlSs(this.selectedPlan.packageid, null).subscribe(
      {
        next: (res) => {

          if (res && res.length > 0) {
            if (this.historyState.mlsData && this.historyState.from != 'plans') {
              this.selectedMls = this.historyState.mlsData;
              for (let idx = 0; idx < res.length; idx++) {
                let ele = res[idx];
                let isFlag = true;
                for (let index = 0; index < this.historyState.mlsData.length; index++) {
                  let element = this.historyState.mlsData[index];

                  if (element.id == ele.id) {
                    ele.isDefault = element.isDefault;
                    ele.isIncluded = true;
                    if (element.lockbox && element.lockbox.isLockIncluded) {
                      ele.lockbox.isLockIncluded = true;
                    }
                    ele.price = ele.price && ele.price != '' ? ele.price : 0;
                    this.mlsService.push(ele);
                    isFlag = false;
                    break;
                  }
                }
                if (isFlag) {
                  if (ele.price == 0) {
                    ele.isDefault = true;
                  } else {
                    ele.isDefault = false;
                  }

                  if (ele.lockbox) {
                    ele.lockbox.isLockIncluded = false;
                  }

                  if (ele.included) {
                    ele.isIncluded = true;
                    this.selectedMls.push(ele);
                    this.calculateTotal();
                  } else {
                    ele.isIncluded = false;
                  }
                  ele.price = ele.price && ele.price != '' ? ele.price : 0;
                  this.mlsService.push(ele);
                }
              }
            } else {
              for (let index = 0; index < res.length; index++) {
                let element = res[index];
                if (element.price == 0) {
                  element.isDefault = true;
                } else {
                  element.isDefault = false;
                }

                if (element.lockbox) {
                  element.lockbox.isLockIncluded = false;
                }

                if (element.included) {
                  element.isIncluded = true;
                  this.selectedMls.push(element);
                  this.calculateTotal();
                } else {
                  element.isIncluded = false;
                }
                element.price = element.price && element.price != '' ? element.price : 0;
                this.mlsService.push(element);
              }
            }
            this.isButtonLoader = false;

          } else {
            this.isButtonLoader = false;
            console.log('GetMlSs Fails!!!!');
            this.toastService.toast('MLS missing!!!!, MLS is not available for selected property FIPS code', ToastType.Error);
          }
        },
        error: (err) => {
          this.isButtonLoader = false;
          console.log("GetMlSs err : ", err);
          this.toastService.toast('MLS missing!!!!, MLS is not available for selected property FIPS code', ToastType.Error);
        }
      }
    );
  }

  addonChange() {
    this.isAddonClosed = !this.isAddonClosed;
  }

  // checking the device width
  deviceWidth: number;
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.deviceWidth = window.innerWidth;
    // if the width is greater than 767 then
    // changing value to true
    if (this.deviceWidth < 766) {
    } else {
      this.isAddonClosed = true;
    }
  }


  addButton(data) {
    if (data.isAdded) {
      data.isAdded = false;
      for (let index = 0; index < this.selectedAddons.length; index++) {
        let element = this.selectedAddons[index];
        if (element.id == data.id) {
          this.selectedAddons.splice(index, 1);
          break;
        }
      }
    } else {
      data.isAdded = true;
      this.selectedAddons.push(data);
    }
    this.calculateTotal();

  }

  removeAddon(data, i) {
    data.isAdded = false;
    this.selectedAddons.splice(i, 1);
    this.calculateTotal();

  }

  addMLS(data) {

    if (data.isIncluded) {
      data.isIncluded = false;
      for (let index = 0; index < this.selectedMls.length; index++) {
        let element = this.selectedMls[index];
        if (element.id == data.id) {
          this.selectedMls.splice(index, 1);
          break;
        }
      }
    } else {
      data.isIncluded = true;
      this.selectedMls.push(data);
    }
    this.calculateTotal();

  }

  changeSwitch(event, data) {
    if (data.lockbox && event) {
      data.lockbox.isLockIncluded = true;
    } else {
      data.lockbox.isLockIncluded = false;
    }

    for (let index = 0; index < this.selectedMls.length; index++) {
      let element = this.selectedMls[index];
      if (data.id == element.id) {
        if (element.lockbox) {
          if (event) {
            if (element.price && element.price != '') {
              element.price = element.price + element.lockbox.price;
            } else {
              element.price = element.lockbox.price;
            }
            element.lockbox.isLockIncluded = true;
          } else {
            element.price = element.price - element.lockbox.price;
            element.lockbox.isLockIncluded = false;
          }
        }
      }
    }

    this.calculateTotal();
  }

  removeMls(data, i) {
    data.isIncluded = false;
    if (data.lockbox) {
      data.lockbox.isLockIncluded = false;

    }
    this.selectedMls.splice(i, 1);
    this.calculateTotal();
  }

  calculateTotal() {
    this.totalAmount = this.selectedPlan.price;
    for (let index = 0; index < this.selectedAddons.length; index++) {
      this.totalAmount = this.totalAmount + this.selectedAddons[index].price;
    }
    for (let index = 0; index < this.selectedMls.length; index++) {
      let element = this.selectedMls[index]
      this.totalAmount = this.totalAmount + element.price;
      // if (element.lockbox && element.lockbox.isLockIncluded) {
      //   this.totalAmount = this.totalAmount + element.lockbox.price;
      // }
    }
  }

  back() {
    this.router.navigateByUrl('/plans', {
      state: this.historyState,
    });

  }

  continue() {
    if (this.selectedMls.length > 0) {
      this.isLoader = true;
      let updateInput = {
        updatedDate: new Date()
      }
      if (!this.historyState.completedIndex || this.historyState['completedIndex'] < 2.1) {
        updateInput['stage'] = 2.1;
        // updateInput["stageName"] = "Add-Ons";
      }

      if (this.historyState.stageName) {
        if (this.historyState.stageName.split(',').indexOf('Add-Ons') <= -1) {
          updateInput["stageName"] = "Add-Ons" + "," + this.historyState.stageName;
        }
      } 
      // else {
      //   updateInput["stageName"] = "Add-Ons" + "," + "Home Details";
      // }

      updateInput["totalAmount"] = this.totalAmount;
      updateInput["mlsData"] = this.selectedMls;
      if (this.selectedAddons.length > 0) {
        updateInput["addOnsData"] = this.selectedAddons;
      }

      this.myListingsService.UpdateListing(this.myListingId, updateInput).subscribe(
        {
          next: (res) => {
            if (!this.historyState.completedIndex || this.historyState['completedIndex'] < 2.1) {
              this.historyState['completedIndex'] = 2.1;
            }
            this.historyState['totalAmount'] = this.totalAmount;
            this.historyState['addOnsData'] = this.selectedAddons;
            this.historyState['mlsData'] = this.selectedMls;
            this.historyState['from'] = null;
            this.historyState.stageName = updateInput["stageName"];
            this.isLoader = false;

            this.router.navigateByUrl('/review', {
              state: this.historyState,
            });

          },
          error: (err) => {
            console.log('UpdateListing err!!!!');
            this.isLoader = false;
            console.log(err);
          }
        }
      );

    } else {
      this.toastService.toast('Choose a MLS to Continue', ToastType.Error);
    }
  }
}
